
import React      from 'react';
import CSSModules from 'react-css-modules';

import style      from './style.scss';
import classnames from 'classnames/bind';

import PageLink from '../PageLink';

class EventPreview extends React.Component {

    _getEventAddress(event) {

        if (event.venue && event.venue.address) {

            return (
                <span className={style['course-info__value']}>
                    { event.venue.address.address_1 }, { event.venue.address.town_city }
                </span>
            );
        }

        return <span className={style['course-info__value']}>&ndash;</span>;
    }

    _getFullyBookedMessage() {

        if (this.props.event.fully_booked) {

            return (
                <span className={style['fully-booked']}>Fully booked</span>
            );
        }
    }

    _getLastPlaceMessage() {


        if(!this.props.event.fully_booked && this.props.event.attendees) {
            const placesLeft = this.props.event.max_delegates - this.props.event.attendees.length

            if(placesLeft <= 3) {

                return (
                    <span className={style['fully-booked']}>Last Few Places Left</span>
                );
            }
        }
    }

    render() {

        const { event } = this.props;

        return (

            <article className={style['event-details']}>

                <h3 className={style['module-name']}>
                    { event.course.module.name }
                </h3>

                <h2 className={style['course-name']}>
                    <PageLink to={ `/events/${ event.id }` }>
                        { event.course.name }
                    </PageLink>
                </h2>

                <div className={style['course-info']}>

                    <div className={style['course-info__row']}>
                        <span className={style['course-info__key']}>Date</span>
                        {event.multiple_days && (
                            event.multiple_days_events.map((event, index) => {
                                return (
                                    <div>

                                    <span className={style['multi-event-course-info__value']}>
                                        <b>Day { index + 1}</b><br/>
                                        { event.date_range }
                                    </span>

                                    </div>)
                            })
                        )}
                        {!event.multiple_days && (
                            <span className={style['course-info__value']}>{ event.date_range }</span>
                        )}
                    </div>

                    <div className={style['course-info__row']}>
                        <span className={style['course-info__key']}>Location</span>

                        { this._getEventAddress(event) }
                    </div>

                    <div className={style['course-info__row']}>
                        <span className={style['course-info__key']}>CPD</span>
                        <span className={style['course-info__value']}>
                            { event.padded_cpd_hours } hours&nbsp;
                            { event.padded_cpd_minutes } minutes
                        </span>
                    </div>

                </div>

                { this._getFullyBookedMessage() }

                { this._getLastPlaceMessage() }

            </article>
        );
    }
}

export default CSSModules(EventPreview, style);


// WEBPACK FOOTER //
// ./components/EventPreview/index.js